module.exports = __webpack_public_path__ + "static/media/2SHARES.8b073a9a.png";